import { Row, Form } from 'react-bootstrap';

import './styles.scoped.css';

export const AnnualAuditForm = ({ form, handleChange, errors }) => (
  <div className="filters-container">
    <span>
      This report returns the Payroll Check Register for the 401K drivers for the selected Check Date range. Empower
      Retirement participants only — Lily and Toyota are excluded.
    </span>
    <div className="filter-row" style={{ marginTop: '30px' }}>
      <Form.Group as={Row} style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '220px' }}>
          <div className="required">Check Date</div>
        </Form.Label>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="FromCheckdate"
          aria-label="From Check Date"
          value={form?.FromCheckdate || ''}
          onChange={handleChange}
          max={form?.ToCheckdate || undefined}
        />
        <span className="date-divider">to</span>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="ToCheckdate"
          aria-label="To Check Date"
          value={form?.ToCheckdate || ''}
          onChange={handleChange}
          min={form?.FromCheckdate || undefined}
        />
      </Form.Group>
    </div>
    {errors?.Checkdate && <div className="field-error">{errors.Checkdate}</div>}
  </div>
);
